const prefix = 'searchInput: '

/** Search History Action Names */
export const RECEIVE_SEARCH_HISTORY = `${prefix}Search history: Get search history`
export const UPDATE_SEARCH_HISTORY = `${prefix}Search history: Update search history`
/** */

export const REQUEST_COMPLETIONS = `${prefix}Send an async autocomplete request to server`
export const RECEIVE_COMPLETIONS = `${prefix}Update the state with the fetched completions result`
export const CLEAR_COMPLETIONS = `${prefix}Remove the previous fetched completions.`
export const CHOOSE_SUGGESTION = `${prefix}Choose an autocomplete suggestion.`
export const CANCEL_SEARCH = `${prefix}Cancel search`
